<template>
  <div class="fiexd_progress" v-if="percenNum != 0 && percenNum != 100">
    <el-progress
      :text-inside="true"
      :stroke-width="20"
      :percentage="percenNum"
    ></el-progress>
  </div>
</template>

<script>
export default {
  name: 'fileLoading',
  props: ['percentName'],
  data() {
    return {
      percenNum: 0,
    }
  },
  computed: {
    haha() {
      this.percenNum = Math.round(this.$store.state.progressNum * 100)
      return this.percenNum
    },
  },
  methods: {},
  watch: {
    haha(val, newval) {
      this.percenNum = Math.round(newval * 100)
      if (this.percenNum > 50) {
        this.percenNum = 100
      }
    },
  },
}
</script>

<style>
.fiexd_progress {
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 999;
}
.el-progress-circle {
  width: 80px !important;
  height: 80px !important;
}
</style>
